<h4>
    This {{data.self.tooltip(data.data)}} has {{data.data.shortcuts_count}} FlyCut{{data.data.shortcuts_count > 1 ? 's' : ''}} attached to it. 
    You can move {{data.data.shortcuts_count  > 1 ? 'them' : 'the flycut'}} to another {{data.self.tooltip(data.data).toLowerCase()}}, or it will be 
    moved to default category.
</h4>
<br>
<div vng-dialog-title>What do you want to do?</div>
<!-- R12: mat-radio-group/-button -> vng-radio-group/-button; Material's inline
     layout here -> orientation="horizontal" (the .right-space gap class is unchanged). -->
<vng-radio-group aria-label="Select an option" orientation="horizontal" [formControl]="deleteType">
    <vng-radio-button color="primary" value="move" class="right-space">Move {{data.data.shortcuts_count  > 1 ? 'all FlyCuts' : 'the flycut'}} to</vng-radio-button>
    <vng-radio-button color="primary" value="remove">Delete Category</vng-radio-button>
</vng-radio-group>
<div style="display: flex" class="top-gap" *ngIf="deleteType.value == 'move'">
    <!-- R5: mat-select (no search here — small flat list) -> vng-select, data-driven. -->
    <vng-select class="category-picker" label="Pick a category" placeholder="Pick a category" [formControl]="category" [options]="categoryOptions">
    </vng-select>
</div>
<div style="display: flex; gap: 15px" class="top-gap">
    <!-- P1: dismiss buttons use `outline` (light border), not `secondary`
         (near-black border). -->
    <button style="flex: 1" class="btn-cta btn-secondary" type="button" vng-button variant="outline" tabindex="2"
        (click)="onNoClick()">Cancel</button>
    <button style="flex: 1" (click)="onSaveCLick()" class="btn-cta btn-primary"
    type="button" vng-button variant="primary" tabindex="-1">Delete</button>
</div>